var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C2.89543 2 2 2.89543 2 4V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V4C18 2.89543 17.1046 2 16 2H4ZM6 8C5.44772 8 5 8.44772 5 9V14C5 14.5523 5.44772 15 6 15C6.55228 15 7 14.5523 7 14V9C7 8.44772 6.55228 8 6 8ZM9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6V14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14V6ZM14 10C13.4477 10 13 10.4477 13 11V14C13 14.5523 13.4477 15 14 15C14.5523 15 15 14.5523 15 14V11C15 10.4477 14.5523 10 14 10Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartSquare);
export default __webpack_public_path__ + "static/media/bar-chart-square.71d3e7b7779805d07dd555b1d4cf61e0.svg";
export { ForwardRef as ReactComponent };